export
const name: string = "LightingInVs";

export
const preproc: string = `
    #define BIT16 1
`;

export
const declaration: string = `
    uniform       int    u_ambient_is_diffuse;
    uniform       float  u_ambient_light_intensity;
`;

export
const varyings: string = `
    varying vec3    v_diffuse_color;
    varying vec3    v_specular_color;
    varying vec3    v_simple_diffuse_color;
    varying vec3    v_simple_specular_color;
`;

export
const implementation: string = `
    lowp vec4 applyLighting(const SMaterial aSurfaceMaterial)
    {
         // when the ambient equals diffuse color uniform is enabled, then instead of using the surface ambient color, we use the diffuse color
        vec3 ambientSurfaceColor = aSurfaceMaterial.ambient;
        if (u_ambient_is_diffuse == 1) {
             ambientSurfaceColor = aSurfaceMaterial.diffuse;
        }

        float alpha = aSurfaceMaterial.alpha * (1.0 - aSurfaceMaterial.transparency);
        vec3 ambient = ambientSurfaceColor * u_ambient_light_intensity;

    // Apply Ambient Occlusion
    #ifdef SSAO
        float ssao = vec4ToFloat(texture2D(u_ssao_texture, toViewCoords((v_clip_space_position.xy / v_clip_space_position.w) * 0.5 + 0.5, u_view)));
    #else
        float ssao = 1.0;
    #endif

    // Apply Shadow Maps
    #if defined(SHADOW_MAP) || defined(SHADOW_MAP_VARIANCE)
        float shadow = getShadow() * alpha;
    #else
        float shadow = 1.0;
    #endif

        vec4 finalColor;

        if (aSurfaceMaterial.shading == 1) {
            vec3 diffuse = aSurfaceMaterial.diffuse * v_diffuse_color;
            vec3 specular = aSurfaceMaterial.specular * v_specular_color;

            finalColor = vec4((ambient + (diffuse + specular) * shadow) * ssao, alpha);
        }
        else {
            vec3 diffuse = aSurfaceMaterial.diffuse * v_simple_diffuse_color;
            vec3 specular = aSurfaceMaterial.specular * v_simple_specular_color;

            finalColor = vec4((ambient + (diffuse + specular) * shadow) * ssao, alpha);
        }

        #ifdef FOG
            finalColor.rgb = applyFog(finalColor.rgb);
        #endif

        return finalColor;
    }
`;
